// @core/api/endpoints/affiliate/list_offers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListOffersResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List offers
 * Lists offers. Affiliates see only public or approved offers. Admins see all.
 */
export async function ListOffers(
  params?: PaginatedRequest & {
    payout_type?: string | number | boolean;
    q?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListOffersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/offers`;
  const requestOptions = options;
  return client.get<ListOffersResponse>(requestPath, { ...requestOptions, params });
}
